





























































































import { Component, Vue } from "vue-property-decorator";
import { mapGetters, mapState } from "vuex";
import {
  BButton,
  BCard,
  BCol,
  BFormCheckbox,
  BFormInput,
  BFormInvalidFeedback,
  BFormValidFeedback,
  BJumbotron,
  BRow,
} from "bootstrap-vue";

@Component({
  components: {
    "b-button": BButton,
    "b-card": BCard,
    "b-col": BCol,
    "b-form-checkbox": BFormCheckbox,
    "b-form-input": BFormInput,
    "b-form-invalid-feedback": BFormInvalidFeedback,
    "b-form-valid-feedback": BFormValidFeedback,
    "b-jumbotron": BJumbotron,
    "b-row": BRow,
  },
  computed: {
    verifyNewCourse(): boolean {
      // @ts-expect-error: no u typescript, this does exist
      return this.newCourse.match("^[a-zA-Z]{4}[-_\\s]\\d{4}$") !== null;
    },
    priorCourses(): string[] {
      // @ts-expect-error: no u typescript, this does exist
      return Object.keys(this.getPriorCourses()).sort();
    },
    ...mapGetters("prerequisites", ["getPriorCourses"]),
    ...mapState(["courseIdToCourse"]),
    prerequisiteChecking: {
      get() {
        return this.$store.state.prerequisites.enableChecking;
      },
      set() {
        const new_val = !this.$store.state.prerequisites.enableChecking;
        this.$store.commit("prerequisites/togglePrerequisiteChecking", new_val);
      },
    },
  },
})
export default class Prerequisites extends Vue {
  newCourse = "";

  formatCourse(value: string): string {
    return value
      .toUpperCase()
      .replace("_", "-")
      .replace(" ", "-")
      .substring(0, 9);
  }

  addCourse(): void {
    // @ts-expect-error: no u typescript, this does exist
    if (this.verifyNewCourse) {
      this.$store.commit("prerequisites/addPriorCourse", this.newCourse);
    }
  }

  removeCourse(course: string): void {
    this.$store.commit("prerequisites/removePriorCourse", course);
  }
}
